import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

import { provideStore } from '@ngxs/store';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';

import { routes } from './app.routes';

import { MessageService } from 'primeng/api';

import { SiteState } from '@stores/site';
import { OrganizationsState } from '@stores/organizations';
import { UserState } from '@stores/user';
import { afterDeserializer, beforeSerializer } from '@core/utils/ngxs.utils';
import { MembersState } from '@stores/members';
import { SeasonsState } from '@stores/seasons';
import { provideHttpClient } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideStore(
      [SiteState, UserState, OrganizationsState, MembersState, SeasonsState],
      withNgxsStoragePlugin({
        keys: [UserState, OrganizationsState, MembersState],
        beforeSerialize: beforeSerializer,
        afterDeserialize: afterDeserializer,
        migrations: [
          {
            version: 1,
            versionKey: 'storageVersion',
            migrate: (state: any) => ({ ...state, storageVersion: 2 }),
          },
        ],
      })
    ),
    provideAnimationsAsync(),
    provideHttpClient(),
    providePrimeNG({
      theme: {
        preset: Lara,
        // options: {
        //   // prefix: 'tr',
        //   darkModeSelector: '.app-dark',
        //   cssLayer: {
        //     name: 'primeng',
        //     order: 'primeng',
        //   },
        // },
      },
    }),
  ],
};
